import React, { useState, useEffect, useRef } from 'react';
import { useSwipeable } from 'react-swipeable';
import axios from 'axios';
import { FaUser, FaHeart, FaClock } from "react-icons/fa";



const NewsHeadline = () => {
  const [headlinesData, setHeadlinesData] = useState([]); // State to store fetched headlines data
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isSwiping, setIsSwiping] = useState(false);
  const intervalRef = useRef(null);

  const fetchHeadlines = async () => {
    const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/news_headline`, {});
    console.log(data);
    setHeadlinesData(data.headlines); // Access the headlines property
  };

  const startAutoRotation = () => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(() => {
      if (!isSwiping) {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % headlinesData.length);
      }
    }, 3000);
  };

  const stopAutoRotation = () => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => {
    fetchHeadlines(); // Fetch headlines when the component mounts
    startAutoRotation();
    return () => stopAutoRotation();
  }, [isSwiping, headlinesData.length]); // Re-run when the length of headlinesData changes

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % headlinesData.length);
    startAutoRotation();
  };

  const goToPrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + headlinesData.length) % headlinesData.length);
    startAutoRotation();
  };

  const handlers = useSwipeable({
    onSwipeStart: () => setIsSwiping(true),
    onSwipeEnd: () => setIsSwiping(false),
    onSwipedLeft: goToNext,
    onSwipedRight: goToPrev,
    trackMouse: true
  });


  return (
    <div className="hm-headline-carousel" {...handlers}>
      <div
        className="hm-headline-container"
        style={{
          transform: `translateX(-${currentIndex * 100}%)`,
          transition: isSwiping ? 'none' : 'transform 0.3s ease-in-out',
          display: 'flex',
          width: `${headlinesData.length * 100}%`
        }}
      >
        {headlinesData.map((headline) => (
          <div key={headline.id} style={{ width: '100%', flexShrink: 0 }}>
          
              <div className="hm-headline hm-headline-at" onClick={() => window.location.href = `/community/article/${headline.id}`}>
                <div className="hdln-preview"><img src={headline.preview}></img></div>
                <div className="hdln-inner">
                  <div className="hdln-title">{headline.title}
                    <div className='hdln-category' style={{backgroundColor:headline.categoryColor}}>
                        {headline.category}
                    </div>
                  </div>

                    <div className='hm-hdln-flex'>
                        <div className="hdln-info"><FaUser /> {headline.writer}</div>
                        <div className="hdln-info"><FaHeart /> {headline.like}</div>
                    </div>
                    <div className="hdln-date"><FaClock /> {headline.date}</div>
                </div>
              </div>

          </div>
        ))}
      </div>
      <div className="hm-headline-indicators">
        {headlinesData.map((_, index) => (
          <span
            key={index}
            className={`indicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => {
              setCurrentIndex(index);
              startAutoRotation();
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default NewsHeadline;
